<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../../../helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Services
	import { postReq } from '../../../../../services/http';
	//Stores
	//Design system components
	import { Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Request } from '../../../../../types/requests/request';
	import type { Device } from '../../../../../types/Device';
	export let disabled: boolean;
	export let device: Device;
	export let error = false;
	export const save = async (): Promise<Request> => {
		value = Math.round(value);
		if (value == settings.blind_time_minutes) return { isok: true };
		return await postReq(
			`/device/generic_command`,
			{
				id,
				command: `motion_blind_time_minutes`,
				payload: JSON.stringify({ value: Number(value) }),
			},
			10000,
		);
	};

	const id = real_id(device.id),
		settings = readDeviceSettings(id)?.motion,
		min = 1,
		max = 1440;

	let value = settings.blind_time_minutes;

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);
	$: error = !!inputData.error;
</script>

<Text
	styleType="body-small"
	class={classMap({
		'mb-xs': true,
		'text-color-3': disabled,
	})}
>
	{$format('motion_blind_time_message', {
		default: 'Blind time in minutes  after last detected motion.',
	})}
</Text>

<Input
	icon="fas fa-eye-slash"
	class="mb-m"
	bind:value
	{disabled}
	info={inputData.info}
	error={!disabled ? inputData.error : ''}
	type="number"
	step={1}
	id="input-wpdwsew"
	aria-label={$format('motion_blind_time_message', {
		default: 'Blind time in minutes after last detected motion.',
	})}
/>
